var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeadLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 103,
    viewBox: "0 0 236 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6161 0.0999756H0.911133V19.504H28.5471V103H48.8331V19.504H76.6161V0.0999756Z",
    fill: "#38D68B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.85 0.0999756H214.976L185.576 48.757L156.029 0.0999756H135.155V103H155.441V36.409L184.4 84.037H186.752L215.711 36.262V103H235.85V0.0999756Z",
    fill: "#38D68B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.583 0.0999756C95.2246 0.0999756 90.8809 4.44371 90.8809 9.80198V9.80198C90.8809 15.1602 95.2246 19.504 100.583 19.504H103.465C108.823 19.504 113.167 15.1602 113.167 9.80198V9.80198C113.167 4.44371 108.823 0.0999756 103.465 0.0999756H100.583Z",
    fill: "#2EB675"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 23.1519V32.5559H113.167V23.1519H90.8809Z",
    fill: "#2EB675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 35.1V44.504H113.167V35.1H90.8809Z",
    fill: "#2EB675"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 47.1V56.504H113.167V47.1H90.8809Z",
    fill: "#2EB675"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8809 58.9514V103H113.167V58.9514H90.8809Z",
    fill: "#2EB675"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadLogo);
export default __webpack_public_path__ + "static/media/headLogo.f3e99a86f284673cb002b192bc935f85.svg";
export { ForwardRef as ReactComponent };